export const IMG = 'img';
export const DIV = 'div';
export const CLIPPATH = 'clip-path';
export const VIDEO = 'video';
export const TEXT = 'text';
